export default {
  vehicles: {},
  // vehicle status is set in the updatePresence mutation. we use this to keep track of which vehicles are online
  vehicleStatusData: {}, 
 
  // device pres map, key id device id, val is pres object :)
  devicesMapData: {},

  selectedOrg: false,

  loading: false
}